<script>
import VueCharts from 'vue-chartjs'

export default {
  extends: VueCharts.Pie,
  mixins: [VueCharts.mixins.reactiveProp],
  props: ['chartData'], // Nota: deve chiamarsi necessariamente 'chartData'
  mounted () {
    // Questo grafico mostra le Simulazioni Perdenti / Vincenti / Abbandonate
    let data = {
      datasets: [{
        data: this.chartData, // Unico dato inviato dal Parent: [10, 20, 30]
        backgroundColor: ['#208dc8', '#e69024', 'lightgray'] // In ordine => Vincenti, Perdenti, Abbandonate
      }],
      labels: [
          'Vincenti',
          'Perdenti',
          'Abbandonate'
      ]
    };
    let options = {
      legend: {
        display: true,
        position: 'bottom'
      },
      tooltips: {
        callbacks: {
          // Per mostrare la percentuale, oltre al valore fisso
          label: function (tooltipItem, data) {
            try {
              let label = ' ' + data.labels[tooltipItem.index] || '';

              if (label) {
                label += ': '+ data.datasets[0]["data"][tooltipItem.index];
              }
              const sum = data.datasets[0].data.reduce((accumulator, curValue) => {
                return accumulator + curValue;
              });
              const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              label += " (" + Number((value / sum) * 100).toFixed(2) + '%)';
              return label;
            } catch (error) {
              console.log(error);
            }
          }
        }
      }
    }
    
    this.renderChart(data, options);
  }

};
</script>